/* Pet Cameo | v34 | Production date: 2026-10-02 | Matt Font-AI-ne */
(() => {
  'use strict';
  const $ = selector => document.querySelector(selector);
  const pcAsset = name => (window.PetCameoAssets && window.PetCameoAssets[name]) || '';
  if (!$('#shop-form')) return;
  const colors = [
    ['Carbon Grey', '#b6b6b0'], ['White', '#ffffff'], ['Charcoal', '#393c38'], ['Black', '#171e2a'],
    ['Coral', '#fa8d7a'], ['Royal Blue', '#304485'], ['Red', '#bd1505'], ['Forest Green', '#345a36'],
    ['Cream', '#f4ebce'], ['Dark Grey', '#444440'], ['Tan', '#af8967'], ['Orange', '#cc7225'],
    ['Ice Blue', '#dcf7fc'], ['Blush', '#f9cec8'], ['Pink', '#f9d5f5'], ['Sand', '#c8a06b']
  ].map(([name, hex]) => ({ id: name.toLowerCase().replaceAll(' ', '-'), name, hex }));
  const adultSizes = ['Small', 'Medium', 'Large', 'XL', '2XL'];
  // Demo catalog. George supplies real variants.
  const demoProducts = [
    ['sweatshirt', 'Unisex Premium Sweatshirt', 40, adultSizes],
    ['onesie', 'Baby Short Sleeve One Piece', 20, ['3–6 months', '6–12 months', '12–18 months', '18–24 months']],
    ['tshirt', 'Unisex T-Shirt', 40, adultSizes],
    ['mug', 'Mug (with color accent)', 20, ['11 oz', '15 oz']],
    ['hoodie', 'Unisex Hoodie', 45, adultSizes]
  ].map(([id, title, price, sizes]) => ({ id, title, price, currency: 'USD', imageUrl: pcAsset('product-thumb-' + id + '.png'), colors, sizes }));
  const imageLoaded = image => new Promise((resolve, reject) => { if (image.complete && image.naturalWidth) return resolve(); image.onload = () => resolve(); image.onerror = () => reject(new Error('Image failed to load.')); });
  let products = demoProducts;
  let selectedId = 'onesie';
  let colorId = 'white';
  let size = '';
  let artwork = null;
  let busy = false, contextReady = false;
  const selectedProduct = () => products.find(item => item.id === selectedId);
  function status(text, error = false) { $('#cart-status').textContent = text; $('#cart-status').classList.toggle('error', error); }
  // Colors offered for a size: a product can have different colors per size (11 oz vs 15 oz mugs).
  const colorsFor = (product, forSize) => product.combos && product.sizes.length
    ? product.colors.filter(color => product.combos.some(combo => combo.size === forSize && combo.colorId === color.id))
    : product.colors;
  function renderProducts() {
    $('#product-grid').replaceChildren();
    products.forEach(product => {
      const card = document.createElement('label'); card.className = 'product-card';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'product'; input.value = product.id; input.checked = product.id === selectedId; input.setAttribute('aria-label', product.title);
      const image = document.createElement('img'); image.src = product.imageUrl; image.alt = product.title + ' example';
      const title = document.createElement('span'); title.className = 'product-title'; title.textContent = product.title;
      const price = document.createElement('span'); price.className = 'product-price'; price.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: product.currency || 'USD', maximumFractionDigits: 2 }).format(product.price);
      card.append(input, image, title, price); $('#product-grid').append(card);
      input.addEventListener('change', () => { selectedId = product.id; size = product.sizes[0] || ''; colorId = colorsFor(product, size)[0]?.id || ''; renderSelection(); status(''); });
    });
  }
  function renderSelection() {
    const product = selectedProduct(); if (!product) return; $('#selected-product').textContent = product.title;
    if (!product.sizes.includes(size)) size = product.sizes[0] || '';
    const colors = colorsFor(product, size);
    if (!colors.some(item => item.id === colorId)) colorId = colors[0]?.id || '';
    $('#product-colors').replaceChildren();
    $('.shop-colors').hidden = !colors.length;
    colors.forEach(color => {
      const label = document.createElement('label'); label.className = 'swatch'; label.style.setProperty('--swatch', color.hex); label.title = color.name;
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'color'; input.value = color.id; input.checked = color.id === colorId; input.setAttribute('aria-label', color.name);
      input.addEventListener('change', () => { colorId = color.id; $('#selected-color').textContent = color.name; status(''); });
      label.append(input, document.createElement('span')); $('#product-colors').append(label);
    });
    $('#selected-color').textContent = colors.find(item => item.id === colorId)?.name || '';
    $('#product-size').replaceChildren();
    product.sizes.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; option.selected = value === size; $('#product-size').append(option); });
    $('.shop-size').hidden = !product.sizes.length;
  }
  $('#product-size').addEventListener('change', event => { size = event.target.value; renderSelection(); status(''); });
  function setBusy(value, adding = true) {
    busy = value;
    document.querySelectorAll('.shop-options input, .shop-options select, #add-to-cart').forEach(node => { node.disabled = value; });
    $('#shop-form').setAttribute('aria-busy', String(value));
    $('#add-to-cart > span:first-child').textContent = value && adding ? 'Adding…' : 'Add to Cart';
  }
  function request() { return { artwork, productId: selectedId, colorId, size, quantity: 1 }; }
  $('#shop-form').addEventListener('submit', async event => {
    event.preventDefault(); if (busy) return;
    if (!contextReady) { status('Product options are unavailable. Refresh and try again.', true); return; }
    if (typeof window.PetCameoAPI?.addToCart !== 'function') {
      // Preview cart. No real orders, no magic bullshit.
      try {
        const items = JSON.parse(sessionStorage.getItem('petcameo:preview-cart') || '[]');
        if (!Array.isArray(items) || items.some(item => !Number.isSafeInteger(item.quantity) || item.quantity < 1)) throw new Error('Invalid preview cart.');
        items.push({ id: 'preview-' + (globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)), ...request(), artwork: artwork || { imageUrl: $('#shop-artwork').src }, title: selectedProduct().title, price: selectedProduct().price, imageUrl: selectedProduct().imageUrl, colors: selectedProduct().colors, sizes: selectedProduct().sizes, currency: selectedProduct().currency });
        sessionStorage.setItem('petcameo:preview-cart', JSON.stringify(items));
        window.dispatchEvent(new CustomEvent('petcameo:cart-updated', { detail: { cartCount: items.reduce((sum, item) => sum + (item.quantity || 1), 0), preview: true } }));
        status('Added to preview cart!');
      } catch { status('Could not save your preview cart. Please try again.', true); }
      return;
    }
    if (!artwork) { status('Create your pet’s artwork first, then choose your product.', true); return; }
    setBusy(true); status('Adding your design to the cart…');
    try {
      const result = await window.PetCameoAPI.addToCart(request());
      if (!result || result.success !== true) throw new Error('The cart did not confirm your item. Please try again.');
      status('Added to cart! You can add another product using this artwork.');
      window.dispatchEvent(new CustomEvent('petcameo:cart-updated', { detail: result }));
    } catch (error) { status(error instanceof Error ? error.message : 'Could not add your item. Please try again.', true); }
    finally { setBusy(false); }
  });
  const dialog = $('#shop-art-dialog');
  $('#shop-art-image').addEventListener('click', () => { $('#shop-enlarged-art').src = $('#shop-artwork').src; dialog.showModal(); document.body.classList.add('modal-open'); });
  dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => document.body.classList.remove('modal-open'));
  function validImage(value) {
    if (typeof value !== 'string') return false;
    let url; try { url = new URL(value, location.href); } catch { return false; }
    return ['https:', 'http:', 'blob:'].includes(url.protocol) || (url.protocol === 'data:' && /^data:image\/(png|jpeg|webp);base64,/i.test(value));
  }
  async function loadContext() {
    setBusy(true, false);
    try {
      let context;
      if (typeof window.PetCameoAPI?.getShopContext === 'function') context = await window.PetCameoAPI.getShopContext();
      else {
        try { context = { artwork: JSON.parse(sessionStorage.getItem('petcameo:artwork') || 'null') }; } catch { context = {}; }
      }
      if (context?.artwork && validImage(context.artwork.imageUrl)) {
        const image = new Image(); image.src = context.artwork.imageUrl; await imageLoaded(image);
        artwork = context.artwork; $('#shop-artwork').src = artwork.imageUrl; $('#shop-artwork').alt = (artwork.request?.petName || 'Your pet') + ' generated artwork'; $('#artwork-note').hidden = true;
      }
      if (typeof window.PetCameoAPI?.addToCart === 'function' && (!Array.isArray(context?.products) || !context.products.length)) throw new Error('Live cart requires a live catalog.');
      if (Array.isArray(context?.products) && context.products.length) {
        // Reject broken catalogs before rendering.
        const ids = new Set();
        const valid = context.products.every(p => {
          if (!p || typeof p.id !== 'string' || !p.id || ids.has(p.id)) return false;
          ids.add(p.id);
          return typeof p.title === 'string' && Number.isFinite(p.price) && p.price >= 0 && validImage(p.imageUrl) && Array.isArray(p.colors) && p.colors.every(c => c && typeof c.id === 'string' && typeof c.name === 'string' && /^#[0-9a-f]{6}$/i.test(c.hex)) && Array.isArray(p.sizes) && p.sizes.every(s => typeof s === 'string');
        });
        if (!valid) throw new Error('Product options could not be loaded.');
        context.products.forEach(p => { if (!/^[A-Z]{3}$/.test(p.currency || 'USD')) throw new Error('Invalid currency.'); new Intl.NumberFormat('en-US', { style: 'currency', currency: p.currency || 'USD' }); });
        products = context.products; selectedId = products[0].id; size = products[0].sizes[0] || ''; colorId = colorsFor(products[0], size)[0]?.id || '';
        $('#catalog-note').hidden = true; renderProducts(); renderSelection();
      }
      contextReady = true;
    } catch { contextReady = false; status('Could not load your artwork or product options. Try refreshing the page.', true); }
    finally {
      setBusy(false, false); $('#add-to-cart').disabled = !contextReady;
      // The artwork slot stays blank while loading. Without artwork nothing is shown in its place, only a pointer to Create.
      const art = $('#shop-artwork');
      if (!artwork) {
        $('#shop-art-image').hidden = true;
        const note = $('#artwork-note'), createUrl = (window.PetCameoConfig && window.PetCameoConfig.routes && window.PetCameoConfig.routes.create) || 'create.html';
        const link = document.createElement('a'); link.href = createUrl; link.textContent = 'Create it first';
        note.replaceChildren(document.createTextNode('You haven’t created your pet’s artwork yet. '), link); note.hidden = false;
      }
      art.removeAttribute('data-pending');
    }
  }
  // With a live adapter the demo catalog is never shown; products render once the context loads.
  if (typeof window.PetCameoAPI?.getShopContext !== 'function') { renderProducts(); renderSelection(); } else { products = []; $('#catalog-note').hidden = true; }
  window.PetCameoShop = { getSelection: request, ready: loadContext() };
})();
